/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * SES email statistics for a single hourly flush
 * @export
 * @interface SesEmailStatsEntry
 */
export interface SesEmailStatsEntry {
    /**
     * 
     * @type {number}
     * @memberof SesEmailStatsEntry
     */
    date?: number;
    /**
     * 
     * @type {number}
     * @memberof SesEmailStatsEntry
     */
    sent?: number;
    /**
     * 
     * @type {number}
     * @memberof SesEmailStatsEntry
     */
    received_fax?: number;
    /**
     * 
     * @type {number}
     * @memberof SesEmailStatsEntry
     */
    received_results?: number;
    /**
     * 
     * @type {number}
     * @memberof SesEmailStatsEntry
     */
    received_helpdesk?: number;
    /**
     * 
     * @type {number}
     * @memberof SesEmailStatsEntry
     */
    skipped_suppressed?: number;
    /**
     * 
     * @type {number}
     * @memberof SesEmailStatsEntry
     */
    skipped_spam?: number;
    /**
     * 
     * @type {number}
     * @memberof SesEmailStatsEntry
     */
    skipped_error?: number;
    /**
     * 
     * @type {number}
     * @memberof SesEmailStatsEntry
     */
    skipped_ses_disabled?: number;
    /**
     * 
     * @type {number}
     * @memberof SesEmailStatsEntry
     */
    bounced_hard?: number;
    /**
     * 
     * @type {number}
     * @memberof SesEmailStatsEntry
     */
    bounced_soft?: number;
    /**
     * 
     * @type {number}
     * @memberof SesEmailStatsEntry
     */
    bounced_complaint?: number;
}

/**
 * Check if a given object implements the SesEmailStatsEntry interface.
 */
export function instanceOfSesEmailStatsEntry(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function SesEmailStatsEntryFromJSON(json: any): SesEmailStatsEntry {
    return SesEmailStatsEntryFromJSONTyped(json, false);
}

export function SesEmailStatsEntryFromJSONTyped(json: any, ignoreDiscriminator: boolean): SesEmailStatsEntry {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'date': !exists(json, 'date') ? undefined : json['date'],
        'sent': !exists(json, 'sent') ? undefined : json['sent'],
        'received_fax': !exists(json, 'received_fax') ? undefined : json['received_fax'],
        'received_results': !exists(json, 'received_results') ? undefined : json['received_results'],
        'received_helpdesk': !exists(json, 'received_helpdesk') ? undefined : json['received_helpdesk'],
        'skipped_suppressed': !exists(json, 'skipped_suppressed') ? undefined : json['skipped_suppressed'],
        'skipped_spam': !exists(json, 'skipped_spam') ? undefined : json['skipped_spam'],
        'skipped_error': !exists(json, 'skipped_error') ? undefined : json['skipped_error'],
        'skipped_ses_disabled': !exists(json, 'skipped_ses_disabled') ? undefined : json['skipped_ses_disabled'],
        'bounced_hard': !exists(json, 'bounced_hard') ? undefined : json['bounced_hard'],
        'bounced_soft': !exists(json, 'bounced_soft') ? undefined : json['bounced_soft'],
        'bounced_complaint': !exists(json, 'bounced_complaint') ? undefined : json['bounced_complaint'],
    };
}

export function SesEmailStatsEntryToJSON(value?: SesEmailStatsEntry | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'date': value.date,
        'sent': value.sent,
        'received_fax': value.received_fax,
        'received_results': value.received_results,
        'received_helpdesk': value.received_helpdesk,
        'skipped_suppressed': value.skipped_suppressed,
        'skipped_spam': value.skipped_spam,
        'skipped_error': value.skipped_error,
        'skipped_ses_disabled': value.skipped_ses_disabled,
        'bounced_hard': value.bounced_hard,
        'bounced_soft': value.bounced_soft,
        'bounced_complaint': value.bounced_complaint,
    };
}

